// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAo4BXxphcmaYZ3V6NS2BlEhBjNNoGpmZc",
  authDomain: "fwaygo-309023.firebaseapp.com",
  databaseURL: "https://fwaygo-309023-default-rtdb.firebaseio.com",
  projectId: "fwaygo-309023",
  storageBucket: "fwaygo-309023.appspot.com",
  messagingSenderId: "1077750168927",
  appId: "1:1077750168927:web:0bc492b6c6be85e6cb8aea",
  measurementId: "G-EGTX9ZCHGE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);